// Local translations
export const T = {
  en_GB: {
    ok: "OK",
  },
  nb_NO: {
    ok: "OK",
  },
} as const;
